module.exports = ":host .round-btn-left {\n  margin-left: auto; }\n\n:host .btn-label_opacity {\n  opacity: 0.6; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/integrations/shootProof/shootProof-view-block/shootProof-view-block.component.scss
// module id = ./web/modern/components/integrations/shootProof/shootProof-view-block/shootProof-view-block.component.scss
// module chunks = 0